let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kVX56"), load("cQ657")]).then(() => parcelRequire('hWg6N'));